import { ReactElement } from 'react'
import LoadEccentricityFormFields from '@editor/components/CheckSettingsFormFields/LoadEccentricityFormFields'
import { isLoadEccentricityComplete } from '@editor/components/CheckSettingsFormFields/LoadEccentricityFormFields/utils'
import MultiEditCheckSettings from '../MultiEditCheckSettings'
import { MultiEditCheckSettingsElement } from '../MultiEditCheckSettings/types'
import { loadEccentricitySettingsColumns } from './columns'
import {
  buildLoadEccentricitySettingsRow,
  getLoadEccentricitySettings,
  mergeLoadEccentricitySettings,
  normalizeLoadEccentricitySettings,
} from './utils'
import { loadEccentricityMultiEditSchema } from './validationSchema'

interface Props {
  elements: MultiEditCheckSettingsElement[]
}

const MultiEditLoadEccentricity = ({ elements }: Props): ReactElement => (
  <MultiEditCheckSettings
    elements={elements}
    sectionKey="loadEccentricity"
    settingsLabel="Lastexzentrizitäts-Einstellungen"
    getSettings={getLoadEccentricitySettings}
    normalizeSettings={normalizeLoadEccentricitySettings}
    mergeSettings={mergeLoadEccentricitySettings}
    differingSettingsMessage="Elemente haben unterschiedliche Lastexzentrizitäten"
    isFormValid={isLoadEccentricityComplete}
    validationSchema={loadEccentricityMultiEditSchema}
    settingsColumns={loadEccentricitySettingsColumns}
    buildSettingsRow={buildLoadEccentricitySettingsRow}
    data-cy="load-eccentricity-form"
    changeButtonDataCy="load-eccentricity-change-button"
    fields={<LoadEccentricityFormFields memberCheckSettingsSelectedPath="sharedSettings" />}
  />
)

export default MultiEditLoadEccentricity
